/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_TextInputs */



/**
* | output |
* | --- |
* | "Match by Text" |
*
* @param {Metadata_Merge_Match_By_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_text = /** @type {((inputs?: Metadata_Merge_Match_By_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Correspondance par texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übereinstimmung per Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corrispondenza tramite testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Совпадение по тексту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Coincidencia por texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本匹配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストで一致")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट द्वारा मिलान करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correspondência por texto")
	return /** @type {LocalizedString} */ ("Match by Text")
});